var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
/**
 * 通用统计卡片组件
 * 根据传入的数据动态渲染不同数量的统计卡片
 * 不依赖 antd，使用原生 HTML 和 CSS
 */
var GenericCardsStatistic = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b, _c = _a.columns, columns = _c === void 0 ? 4 : _c, _d = _a.gutter, gutter = _d === void 0 ? [16, 0] : _d, _e = _a.cardStyle, cardStyle = _e === void 0 ? {} : _e, _f = _a.showCards, showCards = _f === void 0 ? true : _f, _g = _a.className, className = _g === void 0 ? "" : _g, _h = _a.style, style = _h === void 0 ? {} : _h;
    // 计算每个卡片占用的列数
    var getColSpan = function () {
        return 24 / columns;
    };
    // 渲染单个统计卡片
    var renderStatisticCard = function (item) {
        var _a;
        // 判断是否可点击
        var isClickable = item.clickable === true || !!item.onClick;
        // 处理点击事件
        var handleClick = function (event) {
            console.log("[GenericCardsStatistic] Click handler called for card ".concat(item.key), {
                isClickable: isClickable,
                hasOnClick: !!item.onClick,
                event: event,
            });
            if (isClickable && item.onClick) {
                console.log("[GenericCardsStatistic] Calling item.onClick for card ".concat(item.key));
                item.onClick(item, event);
            }
            else {
                console.log("[GenericCardsStatistic] onClick not called for card ".concat(item.key), {
                    isClickable: isClickable,
                    hasOnClick: !!item.onClick,
                });
            }
        };
        // 处理键盘事件（用于可访问性）
        var handleKeyDown = function (event) {
            if (isClickable && item.onClick && (event.key === "Enter" || event.key === " ")) {
                event.preventDefault();
                item.onClick(item, event);
            }
        };
        // 处理鼠标移入事件
        var handleMouseEnter = function (event) {
            // 可以在这里添加鼠标移入的逻辑
        };
        // 统一缩小字号：标题更小、数值略小；允许调用方通过 valueStyle 覆盖
        var mergedValueStyle = __assign({ fontSize: 22, fontWeight: 600, color: "#262626" }, (item.valueStyle || {}));
        // 处理图标
        var prefixIcon = item.prefix;
        // 格式化数值
        var formatValue = function (value) {
            if (typeof value === "number") {
                if (item.precision !== undefined) {
                    return value.toFixed(item.precision);
                }
                return value.toString();
            }
            return value;
        };
        var statisticContent = (_jsxs("div", __assign({ className: "statistic-content", style: __assign({ textAlign: "center", padding: "16px" }, (_a = item.statisticProps) === null || _a === void 0 ? void 0 : _a.style) }, item.statisticProps, { children: [_jsx("div", __assign({ className: "statistic-title", style: {
                        fontSize: 12,
                        color: "#8c8c8c",
                        marginBottom: "8px",
                    } }, { children: item.title })), _jsxs("div", __assign({ className: "statistic-value", style: mergedValueStyle }, { children: [prefixIcon && (_jsx("span", __assign({ style: { marginRight: "8px", fontSize: "20px" } }, { children: prefixIcon }))), item.formatter
                            ? item.formatter(item.value, item)
                            : formatValue(item.value), item.suffix && (_jsx("span", __assign({ style: { fontSize: "14px", marginLeft: "4px" } }, { children: item.suffix })))] }))] })));
        // 如果显示卡片包装，则用Card包装
        if (showCards) {
            // 先提取样式，避免 cursor 被覆盖
            var _b = item.cardProps || {}, cardPropsStyle = _b.style, restCardProps = __rest(_b, ["style"]);
            // 合并样式，确保 cursor 在最后，不会被其他样式覆盖
            var mergedCardStyle = __assign(__assign(__assign({ background: "#fff", borderRadius: "6px", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.02), 0 1px 6px -1px rgba(0, 0, 0, 0.01), 0 2px 4px 0 rgba(0, 0, 0, 0.01)", border: "1px solid #d9d9d9" }, cardStyle), cardPropsStyle), { 
                // cursor 放在最后，如果可点击则强制设置为 pointer，确保不会被其他样式覆盖
                cursor: isClickable ? "pointer" : undefined });
            // 提取其他 cardProps，避免覆盖我们的属性
            var cardPropsOnClick_1 = restCardProps.onClick, cardPropsOnKeyDown_1 = restCardProps.onKeyDown, cardPropsOnMouseEnter_1 = restCardProps.onMouseEnter, otherCardProps = __rest(restCardProps, ["onClick", "onKeyDown", "onMouseEnter"]);
            // 合并事件处理器
            var handleCardClick = function (event) {
                console.log("[GenericCardsStatistic] Card clicked: ".concat(item.key), {
                    isClickable: isClickable,
                    hasOnClick: !!item.onClick,
                    hasCardPropsOnClick: !!cardPropsOnClick_1,
                    event: event,
                });
                // 先执行我们的 handleClick（如果可点击）
                if (isClickable && item.onClick) {
                    console.log("[GenericCardsStatistic] Calling item.onClick for card ".concat(item.key));
                    item.onClick(item, event);
                }
                // 然后执行 item.cardProps 的 onClick（如果存在）
                if (cardPropsOnClick_1) {
                    console.log("[GenericCardsStatistic] Calling cardProps.onClick for card ".concat(item.key));
                    cardPropsOnClick_1(event);
                }
            };
            var handleCardKeyDown = function (event) {
                if (isClickable) {
                    handleKeyDown(event);
                }
                if (cardPropsOnKeyDown_1) {
                    cardPropsOnKeyDown_1(event);
                }
            };
            var handleCardMouseEnter = function (event) {
                handleMouseEnter(event);
                if (cardPropsOnMouseEnter_1) {
                    cardPropsOnMouseEnter_1(event);
                }
            };
            return (_jsx("div", __assign({ className: "statistic-card", style: mergedCardStyle, onClick: isClickable || cardPropsOnClick_1 ? handleCardClick : undefined, onKeyDown: isClickable || cardPropsOnKeyDown_1 ? handleCardKeyDown : undefined, onMouseEnter: handleCardMouseEnter, role: isClickable ? "button" : otherCardProps === null || otherCardProps === void 0 ? void 0 : otherCardProps.role, tabIndex: isClickable ? 0 : otherCardProps === null || otherCardProps === void 0 ? void 0 : otherCardProps.tabIndex }, otherCardProps, { children: statisticContent })));
        }
        // 否则直接返回统计内容
        return statisticContent;
    };
    // 如果没有数据，返回空
    if (!data || data.length === 0) {
        return null;
    }
    return (_jsx("div", __assign({ className: "statistic-cards-container ".concat(className), style: __assign({ display: "flex", flexWrap: "wrap", marginLeft: -gutter[0] / 2, marginRight: -gutter[0] / 2 }, style) }, { children: data.map(function (item) { return (_jsx("div", __assign({ className: "statistic-card-wrapper", style: {
                width: "".concat(100 / columns, "%"),
                paddingLeft: gutter[0] / 2,
                paddingRight: gutter[0] / 2,
                marginBottom: gutter[1],
            } }, { children: renderStatisticCard(item) }), item.key)); }) })));
};
export default GenericCardsStatistic;
